// @flow
import {
    setNotificationState,
    setPreviousEventsList,
    setNotificationPreviouslyShown,
    setNotificationShownAtTime
} from 'common/redux/actions/eventNotifications';
import { bindActionCreators } from 'redux';
import EventNotificationService from 'common/services/EventNotificationService';

export default function setupEventNotificationService(store) {
    const routerFunctions = {};
    const boundActionCreators = bindActionCreators(
        {
            setNotificationState,
            setPreviousEventsList,
            setNotificationPreviouslyShown,
            setNotificationShownAtTime
        },
        store.dispatch
    );
    const getAppPreferences = () => {
        var state = store.getState();
        return state.appPreferences;
    };

    EventNotificationService.setAppPreferencesGetter(getAppPreferences);
    EventNotificationService.setRouterFunctionsAndBoundActionCreators(
        Object.assign({}, routerFunctions, boundActionCreators)
    );
}
